import { Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';

import { ClaimLinesPartialState } from './claim-lines.reducer';
import { claimLinesQuery } from './claim-lines.selectors';
import {
  LoadClaimLines,
  CreateClaimLine,
  EditClaimLine,
  DeleteClaimLine,
  SubmitClaimLine,
  ListClaimLinesByStatus,
  ListClaimLinesByAssignee,
  AssignClaimLine,
  VerifyClaimLine,
  ApproveClaimLine,
  ReturnClaimLine,
  RejectClaimLine,
  SelectClaimLine
} from './claim-lines.actions';
import { ClaimLineForm } from '@ecosure-suite/shared/util-entities';

@Injectable({
  providedIn: 'root'
})
export class ClaimLinesFacade {
  loaded$ = this.store.pipe(select(claimLinesQuery.getLoaded));
  allClaimLines$ = this.store.pipe(select(claimLinesQuery.getAllClaimLines));
  selectedClaimLines$ = this.store.pipe(
    select(claimLinesQuery.getSelectedClaimLines)
  );

  constructor(private store: Store<ClaimLinesPartialState>) {}

  getAllByClaimId(query: { claimId: number; claimRequestId: number }) {
    this.store.dispatch(new LoadClaimLines(query));
  }

  create(claimLine: ClaimLineForm) {
    this.store.dispatch(new CreateClaimLine(claimLine));
  }

  edit(claimLine: ClaimLineForm) {
    this.store.dispatch(new EditClaimLine(claimLine));
  }

  delete(claimLine: ClaimLineForm) {
    this.store.dispatch(new DeleteClaimLine(claimLine));
  }

  submit(claimLineId: number) {
    this.store.dispatch(new SubmitClaimLine(claimLineId));
  }

  listByStatus(query: {
    status: string;
    currentPage: number;
    itemsPerPage: number;
  }) {
    this.store.dispatch(new ListClaimLinesByStatus(query));
  }

  listByAssignee(query: {
    username: string;
    currentPage: number;
    itemsPerPage: number;
  }) {
    this.store.dispatch(new ListClaimLinesByAssignee(query));
  }

  listByCurrentUser(query: {
    username: string;
    currentPage: number;
    itemsPerPage: number;
  }) {
    this.store.dispatch(new ListClaimLinesByAssignee(query));
  }

  assign(claimLine: {
    claimId: number;
    claimLineId: number;
    username: string;
  }) {
    this.store.dispatch(new AssignClaimLine(claimLine));
  }

  verify(claimLine: { claimLineId: number; comment: string }) {
    this.store.dispatch(new VerifyClaimLine(claimLine));
  }

  approve(claimLine: { claimLineId: number; comment: string }) {
    this.store.dispatch(new ApproveClaimLine(claimLine));
  }

  return(claimLine: { claimLineId: number; comment: string }) {
    this.store.dispatch(new ReturnClaimLine(claimLine));
  }

  reject(claimLine: { claimLineId: number; comment: string }) {
    this.store.dispatch(new RejectClaimLine(claimLine));
  }

  select(claimLineId: number) {
    this.store.dispatch(new SelectClaimLine(claimLineId));
  }
}
